export class OrganisationUser {
    public PhoneNumber: string | undefined;
    public OrganisationName: string | undefined;
    public UserId: number | undefined;
}
